export enum AiChatChristmasBackdropPlacement {
  CARD = 'CARD',
  COMPACT_CARD = 'COMPACT_CARD',
  PROMPT_BOX = 'PROMPT_BOX',
  FLOOR = 'FLOOR',
}

export interface AiChatChristmasBackdropProps {
  placement: AiChatChristmasBackdropPlacement;
}
